import React, { useState } from 'react';
import { Button } from 'antd';
import { CustomerServiceOutlined, LogoutOutlined, LockOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DevBanner, { DEV_BANNER_HEIGHT } from '../components/DevBanner';
import ImpersonationBanner from '../components/ImpersonationBanner';
import ChangePasswordModal from '../components/ChangePasswordModal';
import './PartnerLayout.scss';

const PartnerLayout = ({ children }) => {
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  // Open the partner guide in the reader's current app language.
  const guideLang = (i18n?.language || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';

  return (
    <div
      className="PartnerLayout"
      style={{
        paddingTop: `calc(${DEV_BANNER_HEIGHT}px + var(--impersonation-banner-height, 0px))`,
      }}
    >
      <DevBanner />
      <ImpersonationBanner />
      <header className="partner-header">
        <div className="partner-header-left">
          <h2 className="partner-title">OVO Partner Portal</h2>
        </div>
        <div className="partner-header-right">
          <span className="partner-user-name">{user?.name || user?.email}</span>
          {/* OVO-117 — the partner's support entry point. */}
          <Button type="text" icon={<CustomerServiceOutlined />} onClick={() => navigate('/partner/tickets')}>
            Support
          </Button>
          <Button
            type="text"
            icon={<QuestionCircleOutlined />}
            href={`/partner-guide.html?lang=${guideLang}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Help
          </Button>
          <Button type="text" icon={<LockOutlined />} onClick={() => setChangePasswordOpen(true)}>
            Change Password
          </Button>
          <Button type="text" icon={<LogoutOutlined />} onClick={() => navigate('/logout')}>
            Logout
          </Button>
        </div>
      </header>
      <div className="partner-content">{children}</div>
      <ChangePasswordModal open={changePasswordOpen} onClose={() => setChangePasswordOpen(false)} />
    </div>
  );
};

export default PartnerLayout;
